<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <o-widget-wrapper
      :schema="schema"
      name="entered_by"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        flat
        clearable
        v-model="item.entered_by"
        :items="optionUserItems"
        text-field="username"
        value-field="id"
        :validator="$v.item[schema.fields.entered_by.name]"
        :loading="optionUserWorking"
        name="entered_by"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.entered_by"
        :form-state="formState"
        readonly
      ></o-select>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="created_date"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        v-model="item.created_date"
        name="created_date"
        v-bind="schema.fields.created_date"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        readonly
      ></o-date-time>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="date_raised_quoted"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        v-model="item.date_raised_quoted"
        name="date_raised_quoted"
        v-bind="schema.fields.date_raised_quoted"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        hide-time
      ></o-date-time>
    </o-widget-wrapper>
    <o-widget-wrapper
      v-if="!create"
      :schema="schema"
      name="code"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.code"
        :form-state="formState"
        name="code"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.code"
        readonly
      ></o-text-field>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="raised_by"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.raised_by"
        :items="employee_raisedby_items"
        text-field="full_name"
        value-field="pk"
        sort-field="id"
        :form-state="formState"
        :loading="optionEmployeeWorking"
        name="raised_by"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.raised_by"
        store-name="Employee"
      >
        <!-- add-title="Create New" allow-add -->
        <!-- <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <employee-form
            :item="item"
            :form-state="formState"
            :server-errors="serverErrors"
            in-modal
          ></employee-form>
        </template> -->
      </o-select>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="allocated_to"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.allocated_to"
        :items="optionEmployeeItems"
        text-field="full_name"
        value-field="pk"
        sort-field="id"
        :form-state="formState"
        :loading="optionEmployeeWorking"
        name="allocated_to"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.allocated_to"
        store-name="Employee"
      >
        <!-- add-title="Create New"
        allow-add -->
        <!-- <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <employee-form
            :item="item"
            :form-state="formState"
            :server-errors="serverErrors"
            in-modal
          ></employee-form>
        </template> -->
      </o-select>
    </o-widget-wrapper>
    <br />
    <o-widget-wrapper
      :schema="schema"
      name="job"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <job-search
        v-model="item.job"
        :form-state="formState"
        name="job"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.job"
        @update-job="updateJob"
        :create="create"
        :address="item.site_address"
        :suburb="item.suburb"
        :job_number="item.job_number"
      ></job-search>
    </o-widget-wrapper>
    <br />
    <o-widget-wrapper
      :schema="schema"
      name="builder"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        :value="item.builder__name || item.job__customer__name"
        :items="optionCustomerItems"
        text-field="name"
        value-field="id"
        sort-field="name"
        :form-state="formState"
        :loading="optionCustomerWorking"
        name="builder__name"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.builder__name"
        readonly
      >
      </o-text-field>
    </o-widget-wrapper>
    <!-- <o-widget-wrapper
      :schema="schema"
      name="customer"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.customer"
        :form-state="formState"
        name="customer"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.customer"
        readonly
      ></o-text-field>

    </o-widget-wrapper> -->
    <o-widget-wrapper
      :schema="schema"
      name="site_address"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.site_address"
        :form-state="formState"
        name="site_address"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.site_address"
        readonly
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="suburb"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.suburb"
        :form-state="formState"
        name="suburb"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.suburb"
        readonly
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="supervisor__name"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.supervisor_name"
        :form-state="formState"
        name="supervisor__name"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.supervisor__name"
      >
      </o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="extra_type"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.extra_type"
        :items="optionCodeExtraTypeItems"
        text-field="description"
        value-field="id"
        sort-field="description"
        :form-state="formState"
        :loading="optionCodeExtraTypeWorking"
        name="extra_type"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.extra_type"
        store-name="CodeExtraType"
      >
        <!-- add-title="Create New"
        allow-add -->
        <!-- <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <code-extra-type-form
            :item="item"
            :form-state="formState"
            :server-errors="serverErrors"
            in-modal
          ></code-extra-type-form>
        </template> -->
      </o-select>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="category_of_works"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-multi-checkbox
        :form-state="formState"
        :items="optionCodeCategoryOfWorkItems"
        :label="schema.fields.category_of_works.label"
        :level="level + 1"
        :server-errors="_se.category_of_works"
        :validators="$v.item.category_of_works"
        name="category_of_works"
        store-name="CategoryOfWorks"
        v-model="item.category_of_works"
      >
      </o-multi-checkbox>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="description"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-area
        v-model="item.description"
        :form-state="formState"
        name="description"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.description"
      ></o-text-area>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="quoted_amount"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <!-- <o-overridable-number-field
        v-model="item.quoted_amount_override"
        :form-state="formState"
        name="quoted_amount_override"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.quoted_amount"
        :original-value="item.quoted_amount"
      ></o-overridable-number-field> -->
      <o-money-field
        prepend="$"
        default-class="w-50"
        col-size="6"
        v-model="item.quoted_amount"
        :form-state="formState"
        name="quoted_amount"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.quoted_amount"
      ></o-money-field>
    </o-widget-wrapper>
    <!-- <o-widget-wrapper
      :schema="schema"
      name="amount"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        prepend="$"
        v-model="item.amount"
        :form-state="formState"
        name="amount"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.amount"
      ></o-text-field>
    </o-widget-wrapper> -->
    <br />

    <h3>Files</h3>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="repair_files"
    >
      <file-upload-form-table
        :form-state="formState"
        :label="schema.fields.repair_files.label"
        :level="level + 1"
        :server-errors="_se.repair_files"
        :validators="$v.item.repair_files"
        :parent-id="item.id || 0"
        parent-type="service_extra"
        v-model="item.repair_files"
      >
      </file-upload-form-table>
    </o-widget-wrapper>
    <!-- <o-widget-wrapper
      :schema="schema"
      name="repair_files"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-files-table
        v-model="item.repair_files"
        model-name="FileUpload"
        :users="optionUserItemsById"
        :users-working="optionUserWorking"
        :file-types="optionCodeFileTypeItems"
        :file-types-working="optionCodeFileTypeWorking"
        who-field="who_uploaded"
        when-field="when_uploaded"
        :validator="$v.item.repair_files"
        :form-state="formState"
        :label="schema.fields.repair_files.label"
        :level="level + 1"
        :server-errors="_se.repair_files"
      >
      </o-files-table>
    </o-widget-wrapper> -->
    <!-- UNCOMMENT TO USE Cards
<file-upload-form-cards v-model="item.repair_files"
    :validators="$v.item.repair_files"
    :form-state="formState"
    :label="schema.fields.repair_files.label"
    :level="level+1"
    :server-errors="_se.repair_files">
</file-upload-form-cards>
-->
    <br />
    <o-widget-wrapper
      :schema="schema"
      name="date_po_requested"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        v-model="item.date_po_requested"
        name="date_po_requested"
        v-bind="schema.fields.date_po_requested"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
      ></o-date-time>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="date_declined_by_customer"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        v-model="item.date_declined_by_customer"
        name="date_declined_by_customer"
        v-bind="schema.fields.date_declined_by_customer"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
      ></o-date-time>
    </o-widget-wrapper>
    <br />
    <o-widget-wrapper
      v-if="item.extra_type != extra_type_maintenance_request"
      :schema="schema"
      name="sub_contractor"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.sub_contractor"
        :items="subcontractorSupplierType"
        text-field="name"
        value-field="id"
        sort-field="name"
        :form-state="formState"
        :loading="optionSupplierWorking"
        name="sub_contractor"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.sub_contractor"
        store-name="Supplier"
      >
        <!-- add-title="Create New"
        allow-add -->
        <!-- <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <supplier-form
            :item="item"
            :form-state="formState"
            :server-errors="serverErrors"
            in-modal
          ></supplier-form>
        </template> -->
      </o-select>
    </o-widget-wrapper>
    <br />
    <o-widget-wrapper
      v-if="item.extra_type != extra_type_maintenance_request"
      :schema="schema"
      name="subcontractor_bill_amount"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-money-field
        prepend="$"
        default-class="w-50"
        col-size="6"
        v-model="item.subcontractor_bill_amount"
        :form-state="formState"
        name="subcontractor_bill_amount"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.subcontractor_bill_amount"
      ></o-money-field>
      <!-- <o-text-field
        v-model="item.subcontractor_invoice_amount"
        :form-state="formState"
        name="subcontractor_invoice_amount"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.subcontractor_invoice_amount"
      ></o-text-field> -->
    </o-widget-wrapper>
    <o-widget-wrapper
      v-if="item.extra_type != extra_type_maintenance_request"
      :schema="schema"
      name="approve_subcontractor_payment"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-group-button
        :items="buttonValue"
        v-model="item.approve_subcontractor_payment"
        :form-state="formState"
        :label="schema.fields.approve_subcontractor_payment.label"
        name="approve_subcontractor_payment"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.approve_subcontractor_payment"
      ></o-group-button>
      <!-- <o-speed-select
        v-model="item.approve_subcontractor_payment"
        :form-state="formState"
        name="approve_subcontractor_payment"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.approve_subcontractor_payment"
      ></o-speed-select> -->
      <!-- <o-checkbox
        v-model="item.approve_subcontractor_payment"
        :form-state="formState"
        name="approve_subcontractor_payment"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.approve_subcontractor_payment"
      ></o-checkbox> -->
    </o-widget-wrapper>
    <div v-if="showApproveDetails" class="for-approved-details">
      <o-widget-wrapper
        :schema="schema"
        name="approve_subcontractor_when"
        :validators="$v.item"
        :server-errors="_se"
        :form-state="formState"
      >
        <o-date-time
          v-model="item.approve_subcontractor_when"
          name="approve_subcontractor_when"
          v-bind="schema.fields.approve_subcontractor_when"
          :form-state="formState"
          :validators="$v.item"
          :server-errors="_se"
        ></o-date-time>
      </o-widget-wrapper>

      <o-widget-wrapper
        :schema="schema"
        name="approve_subcontractor_by"
        :validators="$v.item"
        :server-errors="_se"
        :form-state="formState"
      >
        <o-select
          flat
          clearable
          v-model="item.approve_subcontractor_by"
          :items="optionUserItems"
          text-field="username"
          value-field="id"
          :validator="$v.item[schema.fields.approve_subcontractor_by.name]"
          :loading="optionUserWorking"
          name="approve_subcontractor_by"
          :validators="$v.item"
          :server-errors="_se"
          v-bind="schema.fields.approve_subcontractor_by"
          :form-state="formState"
        ></o-select>
      </o-widget-wrapper>
    </div>

    <o-widget-wrapper
      v-if="item.extra_type != extra_type_maintenance_request"
      :schema="schema"
      name="date_subcontractor_paid"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        v-model="item.date_subcontractor_paid"
        name="date_subcontractor_paid"
        v-bind="schema.fields.date_subcontractor_paid"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="comments"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.comments"
        :form-state="formState"
        name="comments"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.comments"
      ></o-text-field>
    </o-widget-wrapper>

    <!-- UNCOMMENT TO USE Cards
<invoice-form-cards v-model="item.invoices"
    :validators="$v.item.invoices"
    :form-state="formState"
    :label="schema.fields.invoices.label"
    :level="level+1"
    :server-errors="_se.invoices">
</invoice-form-cards>
-->
    <br />

    <o-widget-wrapper
      :schema="schema"
      name="cancelled_by"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        flat
        clearable
        v-model="item.cancelled_by"
        :items="optionUserItems"
        text-field="username"
        value-field="id"
        :validator="$v.item[schema.fields.cancelled_by.name]"
        :loading="optionUserWorking"
        name="cancelled_by"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.cancelled_by"
        :form-state="formState"
        @input="checkCancelledBy()"
      ></o-select>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="cancelled_date"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        readonly
        v-model="item.cancelled_date"
        name="cancelled_date"
        v-bind="schema.fields.cancelled_date"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        hide-time
      ></o-date-time>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="maintenance_order_number"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.maintenance_order_number"
        :form-state="formState"
        name="maintenance_order_number"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.maintenance_order_number"
      ></o-text-field>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="completed_date"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        v-model="item.completed_date"
        name="completed_date"
        v-bind="schema.fields.completed_date"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        hide-time
      ></o-date-time>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="purchase_orders"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <service-purchase-order-form-cards
        v-model="item.purchase_orders"
        :validators="$v.item.purchase_orders"
        :form-state="formState"
        :label="schema.fields.purchase_orders.label"
        :level="level + 1"
        :server-errors="_se.purchase_orders"
      >
      </service-purchase-order-form-cards>
      <!-- <invoice-form-table
        v-model="item.invoices"
        :validators="$v.item.invoices"
        :form-state="formState"
        :label="schema.fields.invoices.label"
        :level="level + 1"
        :server-errors="_se.invoices"
      >
      </invoice-form-table> -->
    </o-widget-wrapper>
    <h3>Notes</h3>
    <o-widget-wrapper
      :schema="schema"
      name="repair_notes"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-notes-table
        :form-state="formState"
        :label="schema.fields.service_extra_note.label"
        :level="level + 1"
        :server-errors="_se.service_extra_note"
        :users="optionUserItemsById"
        :users-working="optionUserWorking"
        :validator="$v.item.service_extra_note"
        model-name="Note"
        v-model="item.service_extra_note"
        when-field="when"
        who-field="who"
      >
      </o-notes-table>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="used_materials"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <repair-materials-used-form-table
        v-model="item.used_materials"
        :validators="$v.item.used_materials"
        :form-state="formState"
        :label="schema.fields.used_materials.label"
        :level="level + 1"
        :server-errors="_se.used_materials"
      >
      </repair-materials-used-form-table>
      <!-- UNCOMMENT TO USE Cards
<repair-materials-used-form-cards v-model="item.used_materials"
    :validators="$v.item.used_materials"
    :form-state="formState"
    :label="schema.fields.used_materials.label"
    :level="level+1"
    :server-errors="_se.used_materials">
</repair-materials-used-form-cards>
--> </o-widget-wrapper
    ><br />
    <o-section title="Labour Hours" body-classes="p-0" not-closable>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th class="text-center">Quantity</th>
            <th class="text-center">Labour Rate per hr</th>
            <th class="text-center">Total Cost</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <o-widget-wrapper
                :schema="schema"
                name="labour_hours"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-text-field
                  v-model="item.labour_hours"
                  nolabel
                  :form-state="formState"
                  name="labour_hours"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.labour_hours"
                  @input="compute_labour_total_cost"
                ></o-text-field>
              </o-widget-wrapper>
            </td>

            <td>
              <o-widget-wrapper
                :schema="schema"
                name="labour_hour_rate"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-text-field
                  v-model="item.labour_hour_rate"
                  nolabel
                  :form-state="formState"
                  name="labour_hour_rate"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.labour_hour_rate"
                  @input="compute_labour_total_cost"
                ></o-text-field>
              </o-widget-wrapper>
            </td>

            <td>
              <o-widget-wrapper
                :schema="schema"
                name="labour_total_cost"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-money-field
                  :prepend="moneySymbol"
                  v-model="item.labour_total_cost"
                  nolabel
                  :form-state="formState"
                  name="labour_total_cost"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.labour_total_cost"
                  readonly
                ></o-money-field>
              </o-widget-wrapper>
            </td>
          </tr>
        </tbody>
      </table>
      <o-widget-wrapper
        :schema="schema"
        name="total_cost_of_repair_gst"
        :validators="$v.item"
        :server-errors="_se"
        :form-state="formState"
      >
        <o-money-field
          :prepend="moneySymbol"
          v-model="total_cost_of_repair_gst"
          :form-state="formState"
          name="total_cost_of_repair_gst"
          :validators="$v.item"
          :server-errors="_se"
          v-bind="schema.fields.total_cost_of_repair_gst"
          readonly
        ></o-money-field>
      </o-widget-wrapper>

      <o-widget-wrapper
        :schema="schema"
        name="total_cost_of_repair_inc_gst"
        :validators="$v.item"
        :server-errors="_se"
        :form-state="formState"
      >
        <o-money-field
          :prepend="moneySymbol"
          v-model="total_cost_of_repair_inc_gst"
          :form-state="formState"
          name="total_cost_of_repair_inc_gst"
          :validators="$v.item"
          :server-errors="_se"
          v-bind="schema.fields.total_cost_of_repair_inc_gst"
          readonly
        ></o-money-field>
      </o-widget-wrapper>

      <o-widget-wrapper
        :schema="schema"
        name="amount_adjustment"
        :validators="$v.item"
        :server-errors="_se"
        :form-state="formState"
      >
        <o-money-field
          :prepend="moneySymbol"
          v-model="item.amount_adjustment"
          :form-state="formState"
          name="amount_adjustment"
          :validators="$v.item"
          :server-errors="_se"
          v-bind="schema.fields.amount_adjustment"
          default-class="w-50"
          @input="compute_labour_total_cost"
        ></o-money-field>
      </o-widget-wrapper>
      <o-widget-wrapper
        :schema="schema"
        name="amount"
        :validators="$v.item"
        :server-errors="_se"
        :form-state="formState"
      >
        <o-money-field
          :prepend="moneySymbol"
          v-model="item.amount"
          :form-state="formState"
          name="amount"
          :validators="$v.item"
          :server-errors="_se"
          v-bind="schema.fields.amount"
          readonly
        ></o-money-field>
      </o-widget-wrapper>

      <o-widget-wrapper
        :schema="schema"
        name="charge_subcontractor"
        :validators="$v.item"
        :server-errors="_se"
        :form-state="formState"
      >
        <o-checkbox
          v-model="item.charge_subcontractor"
          :form-state="formState"
          name="charge_subcontractor"
          :validators="$v.item"
          :server-errors="_se"
          v-bind="schema.fields.charge_subcontractor"
        ></o-checkbox>
      </o-widget-wrapper>
    </o-section>
    <br />

    <div v-if="!!item.workflow_instance">
      <trigger-buttons
        :workflow-instance="item.workflow_instance_details"
        :current-user="currentUser"
        :do-save="_doSave"
        :item="item"
        @success="reload"
        :disabled-buttons="trigger_disabled_buttons"
      >
        <template v-slot:waiting_approval>
          <o-widget-wrapper
            :schema="schema"
            name="purchase_order_number"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-text-field
              v-model="item.purchase_order_number"
              :form-state="formState"
              name="purchase_order_number"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.purchase_order_number"
            ></o-text-field>
          </o-widget-wrapper>
        </template>
        <template v-slot:reject_request>
          <o-widget-wrapper
            :schema="schema"
            name="rejection_reason"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-text-area
              v-model="item.rejection_reason"
              :form-state="formState"
              name="rejection_reason"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.rejection_reason"
            ></o-text-area>
          </o-widget-wrapper>
        </template>
        <template v-slot:send-to-supervisor>
          <o-widget-wrapper
            :schema="schema"
            name="terms_and_conditions"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-select
              v-model="item.terms_and_conditions"
              :items="optionTermsAndConditionItems"
              text-field="description"
              value-field="id"
              sort-field="description"
              :form-state="formState"
              :loading="optionTermsAndConditionWorking"
              name="terms_and_conditions"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.terms_and_conditions"
              store-name="TermsAndCondition"
            ></o-select> </o-widget-wrapper
        ></template>
      </trigger-buttons>
    </div>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../vue-ocom/mixins";
import { HasGroupMixin } from "../../../vue-ocom/auth/mixin/AuthFormMixins.js";
import { default as SupplierTypeMixin } from "../../job/mixins/supplier_type_mixin";

import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OOverridableNumberField from "../../../vue-ocom/components/forms/fields/OOverridableNumberField";
import OTextArea from "../../../vue-ocom/components/forms/fields/OTextarea";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OSpeedSelect from "../../../vue-ocom/components/forms/fields/OSpeedSelect";
import OGroupButton from "../../components/group_button/OGroupButton";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";
import OFilesTable from "../../../vue-ocom/components/table/common/OFilesTable";
import OMoneyField from "../../components/money_field/OMoneyField";
import ONotesTable from "../../../vue-ocom/components/table/common/ONotesTable";

import { default as CustomerForm } from "../../customer/components/ItemForm";
import { default as SupervisorForm } from "../../supervisor/components/ItemForm";
import { default as JobForm } from "../../job/components/ItemForm";
import { default as FileUploadFormTable } from "../../file_upload/components/ItemFormTable";
// import { default as FileUploadFormCards } from '../../file_upload/components/ItemFormCards';
import { default as RepairMaterialsUsedFormTable } from "../../repair_materials_used/components/ItemFormTable";
// import { default as RepairMaterialsUsedFormCards } from '../../repair_materials_used/components/ItemFormCards';
//     import { default as NoteFormTable } from '../../note/components/ItemFormTable';
// import { default as NoteFormCards } from '../../note/components/ItemFormCards';
import { default as InvoiceFormTable } from "../../invoice/components/ItemFormTable";
import { default as ServicePurchaseOrderFormCards } from "../../service_purchase_order/components/ItemFormCards";
// import { default as InvoiceFormCards } from '../../invoice/components/ItemFormCards';
import { default as JobSearch } from "../../components/job_search/JobSearch";
import { default as EmployeeForm } from "../../employee/components/ItemForm";
// import OSpeedSelect from '../../../../../asset_register/vue/src/vue-ocom/components/forms/fields/OSpeedSelect.vue';
import { default as CodeCategoryOfWorkForm } from "../../code_category_of_work/components/ItemForm";

import { default as ExtraMaintenanceNoteFormTable } from "../../extra_maintenance_note/components/ItemFormTable";
// import { default as ExtraMaintenanceNoteFormCards } from '../../extra_maintenance_note/components/ItemFormCards';
import OMultiCheckbox from "../../../vue-ocom/components/forms/fields/OMultiCheckbox";
import _ from "lodash";

import moment from "moment";
import { CalculateTotalRepairs } from "@/app/service_repair/utils.js";
import TriggerButtons from "../../../vue-workflow/components/TriggerButtons.vue";
import { default as TermsAndConditionFormTable } from "../../terms_and_condition/components/ItemFormTable";
export default {
  mixins: [
    HasGroupMixin("Administrator"),
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("ServiceExtra"),
    CreateCodeTableFetchMixin([
      "Customer",
      "Supervisor",
      "User",
      "CodeFileType",
      "Employee",
      "CodeExtraType",
      "Supplier",
      "CodeCategoryOfWork",
      "UserRole",
      "TermsAndCondition",
      "CodeSupplierType",
    ]),
    SupplierTypeMixin,
  ],
  components: {
    OOverridableNumberField,
    TermsAndConditionFormTable,
    TriggerButtons,
    OMultiCheckbox,
    ServicePurchaseOrderFormCards,
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,
    OCheckbox,
    OSelect,
    OSpeedSelect,
    OGroupButton,
    OTextField,
    OTextArea,
    OFilesTable,
    EmployeeForm,
    CustomerForm,
    SupervisorForm,
    JobForm,
    OMoneyField,
    FileUploadFormTable,
    //FileUploadFormCards,
    RepairMaterialsUsedFormTable,
    //RepairMaterialsUsedFormCards,
    //        NoteFormTable,
    //NoteFormCards,
    InvoiceFormTable,
    //InvoiceFormCards,
    JobSearch,
    CodeCategoryOfWorkForm,
    ExtraMaintenanceNoteFormTable,
    // ExtraMaintenanceNoteFormCards,
    ONotesTable,
  },
  props: {
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
    create: { type: Boolean, default: false },
    _doSave: { type: Function, default: null },
  },
  data: () => ({
    allUserRoles: [],
    total_cost_of_repair_gst: null,
    total_cost_of_repair_inc_gst: null,
    moneySymbol: "$",
    extra_type_maintenance_request: 5,
    showApproveDetails: false,
    buttonValue: [
      { id: true, color: "#000", textField: "Yes" },
      { id: false, color: "#000", textField: "No" },
    ],
    purchase_order: {
      created_date: null,
      modified_date: null,
      po_number: "",
      date_po_supplied: null,
      invoice_number: "",
      date_invoiced: null,
      invoiced_by: null,
      invoiced_by__username: null,
    },
    schemaModel: cleanUpModel(schema.ServiceExtra, {}),
  }),
  methods: {
    reload(data) {
      this.$emit("reload");
    },
    checkCancelledBy() {
      if (this.item.cancelled_by) {
        this.item.cancelled_date = moment().format("YYYY-MM-DD");
      } else {
        this.item.cancelled_date = null;
      }
    },
    OnBeforeGetEmployeeCodeList(list_options) {
      list_options.query = {
        and: [
          ["department", "eq", 9],
          ["entity", "eq", 1],
        ],
      };
    },
    updateJob(e) {
      this.item.job = e.id;
      this.item.site_address = e.site_address;
      this.item.suburb = e.suburb;

      if (e.customer) {
        this.item.builder = e.customer;
        this.item.builder__name = e.customer__name;
      }
    },

    compute_labour_total_cost() {
      CalculateTotalRepairs(this.item);

      this.total_cost_of_repair_gst = this.item.total_cost_of_repair_gst;
      this.total_cost_of_repair_inc_gst = this.item.total_cost_of_repair_inc_gst;
    },
  },
  computed: {
    employee_raisedby_items() {
      return _.filter(this.optionEmployeeItems, function (o) {
        return o.department === 9 && o.head_of_department === true;
      });
    },
    checkActiveState() {
      const result = this.item.workflow_instance_details.states.filter(
        (state) => state.is_active
      );
      return result.length;
    },
    getoptionUserRoleItems() {
      this.optionUserRoleItems.map((role) => {});
      return this.optionUserRoleItems;
    },
    checkCurrentUser() {
      return this.optionUserItems;
    },
    checkApproveSubcontractorPayment() {
      return this.item.approve_subcontractor_payment;
    },
    checkPO() {
      return this.item.purchase_orders;
    },
    checkLabourHourRate() {
      return this.item.labour_hour_rate;
    },
    checkLabourHours() {
      return this.item.labour_hours;
    },
    checkLabourTotalCost() {
      return this.item.labour_total_cost;
    },
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
    trigger_disabled_buttons() {
      if (this.item) {
        var reject_reason_valid = false;
        if (this.item.rejection_reason) {
          // Make sure more than 3 chars
          if (this.item.rejection_reason.length > 3) {
            reject_reason_valid = true;
          }
        }

        return {
          reject_request: !reject_reason_valid,
          "send-to-supervisor": this.item.terms_and_conditions == null,
        };
      } else {
        return {};
      }
    },
  },
  watch: {
    checkCurrentUser() {
      if (!this.item.entered_by) {
        this.item.entered_by = this.currentUser.id;
      } else {
        this.item.entered_by = this.item.entered_by;
      }
    },
    checkApproveSubcontractorPayment() {
      if (this.checkApproveSubcontractorPayment) {
        this.showApproveDetails = true;
      } else this.showApproveDetails = false;
    },
    checkPO() {
      if (this.item.purchase_orders.length <= 0) {
        const po_number = {
          created_date: null,
          modified_date: null,
          po_number: "",
          date_po_supplied: null,
          invoice_number: "",
          date_invoiced: null,
          invoiced_by: null,
          invoiced_by__username: null,
        };
        this.purchase_order = po_number;
        this.item.purchase_orders.push(this.purchase_order);
      }
    },
    checkLabourHourRate() {
      this.compute_labour_total_cost();
    },
    checkLabourHours() {
      this.compute_labour_total_cost();
    },
    checkLabourTotalCost() {
      this.compute_labour_total_cost();
    },
  },
  created() {
    this.compute_labour_total_cost();
  },

  mounted() {},
};
</script>
